import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/ar';
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

// Get language from localStorage or default to 'en'
const getStoredLanguage = () => {
  try {
    return localStorage.getItem('vendorLanguage') || 'en';
  } catch (e) {
    return 'en';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    lng: getStoredLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false
    }
  });

// Set document direction and moment locale based on language
const updateDocumentForLanguage = (lng) => {
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  moment.locale(lng);
};

// Initialize on load
updateDocumentForLanguage(getStoredLanguage());

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  updateDocumentForLanguage(lng);
  localStorage.setItem('vendorLanguage', lng);
});

export default i18n;
